import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTriangleArrowDown = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M5.841 13.017a1.5 1.5 0 0 1 1.386-.926H10.5V5.636a1.5 1.5 0 1 1 3 0v6.455h3.273a1.5 1.5 0 0 1 1.06 2.56l-4.772 4.774a1.5 1.5 0 0 1-2.122 0l-4.773-4.773a1.5 1.5 0 0 1-.325-1.635'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTriangleArrowDown)
export default ForwardRef
